import { IApplicationState } from '../../types/redux';

export const selectBuilder = (state: IApplicationState) => {
  return state.projectData.builder;
};
